import React from 'react'
import { Controller, type UseFormReturn } from 'react-hook-form'

import { Box, Stack, Typography } from '@mui/material'

import { Switch } from '@repo/ui'

// VERA-914 (Stage B) — Marketing section: consent toggles (owners.
// email_marketing_consent / sms_marketing_consent). Shared verbatim between
// Create Owner and Edit Owner.
export const OwnerMarketingFields = ({ methods }: { methods: UseFormReturn<any> }) => {
  const { control } = methods

  return (
    <Stack spacing={6}>
      <Stack direction="row" alignItems="flex-start" spacing={3}>
        <Controller
          name="email_marketing_consent"
          control={control}
          render={({ field }) => (
            <Switch checked={!!field.value} onChange={(_, checked) => field.onChange(checked)} />
          )}
        />
        <Box>
          <Typography variant="body2">Email marketing consent</Typography>
          <Typography variant="body3" color="text.secondary" sx={{ mt: '2px', lineHeight: 1.5 }}>
            Allow this owner to receive marketing emails.
          </Typography>
        </Box>
      </Stack>

      <Stack direction="row" alignItems="flex-start" spacing={3}>
        <Controller
          name="sms_marketing_consent"
          control={control}
          render={({ field }) => (
            <Switch checked={!!field.value} onChange={(_, checked) => field.onChange(checked)} />
          )}
        />
        <Box>
          <Typography variant="body2">SMS marketing consent</Typography>
          <Typography variant="body3" color="text.secondary" sx={{ mt: '2px', lineHeight: 1.5 }}>
            Allow this owner to receive marketing text messages.
          </Typography>
        </Box>
      </Stack>
    </Stack>
  )
}
